// 3D-значок озвучки в стиле Turkido (стеклянные шарики, public/brand/
// audio-icon-orb-v2.jpg) — единый для всех кнопок «послушать» вместо 🔊.
// Inline-стили: телефон пользователя может держать устаревший CSS-бандл.
// Обычный <img>, а не next/image: картинка крошечная и повторяется десятки
// раз в чате/разговорнике — лишние запросы к оптимизатору ни к чему.
// Текущий набор — «желе» (глянцевые пухлые фигуры в синих тонах Turkido).
// Прежние стеклянно-пузырьковые варианты лежат рядом: audio-icon-orb-v2.jpg,
// slow-icon-orb.jpg.
export const AUDIO_ICON_SRC = '/brand/audio-icon-jelly.jpg'
export const SLOW_ICON_SRC = '/brand/slow-icon-jelly.jpg'

// slow — 3D-черепашка для кнопки ×0.75.
export function AudioOrbIcon({
  size = 20,
  dimmed = false,
  slow = false,
}: {
  size?: number
  dimmed?: boolean
  slow?: boolean
}) {
  return (
    <span
      aria-hidden
      style={{
        position: 'relative',
        display: 'inline-block',
        flexShrink: 0,
        width: size,
        height: size,
        borderRadius: 9999,
        overflow: 'hidden',
        border: '1px solid var(--tk-border)',
        boxShadow: '0 0 10px -3px oklch(0.6 0.19 258 / 0.7)',
        filter: dimmed ? 'grayscale(1) opacity(0.5)' : undefined,
        verticalAlign: 'middle',
      }}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={slow ? SLOW_ICON_SRC : AUDIO_ICON_SRC}
        alt=""
        width={size}
        height={size}
        style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }}
      />
    </span>
  )
}
